import { createSlice } from '@reduxjs/toolkit';

const notificationsSlice = createSlice({
    name: 'notifications',
    initialState: {
        notifications: { data: null, loading: false, error: null }, // Fetch notifications
        markRead: { loading: false, error: null }, // Mark notification as read
        deleteNotification: { loading: false, error: null }, // Delete notification
    },
    reducers: {
        // Start actions
        fetchNotificationsStart: (state) => {
            state.notifications.loading = true;
            state.notifications.error = null;
        },
        markNotificationReadStart: (state) => {
            state.markRead.loading = true;
            state.markRead.error = null;
        },
        deleteNotificationStart: (state) => {
            state.deleteNotification.loading = true;
            state.deleteNotification.error = null;
        },

        // Success actions
        fetchNotificationsSuccess: (state, action) => {
            state.notifications.loading = false;
            state.notifications.data = action.payload;
        },
        markNotificationReadSuccess: (state, action) => {
            state.markRead.loading = false;
            state.notifications.data = state.notifications.data.map((notification) =>
                notification.id === action.payload.id ? { ...notification, read: true } : notification
            );
        },
        deleteNotificationSuccess: (state, action) => {
            state.deleteNotification.loading = false;
            state.notifications.data = state.notifications.data.filter(
                (notification) => notification.id !== action.payload.id
            );
        },

        // Fail actions
        fetchNotificationsFail: (state, action) => {
            state.notifications.loading = false;
            state.notifications.error = action.payload;
        },
        markNotificationReadFail: (state, action) => {
            state.markRead.loading = false;
            state.markRead.error = action.payload;
        },
        deleteNotificationFail: (state, action) => {
            state.deleteNotification.loading = false;
            state.deleteNotification.error = action.payload;
        },
    },
});

export const {
    fetchNotificationsStart,
    fetchNotificationsSuccess,
    fetchNotificationsFail,
    markNotificationReadStart,
    markNotificationReadSuccess,
    markNotificationReadFail,
    deleteNotificationStart,
    deleteNotificationSuccess,
    deleteNotificationFail,
} = notificationsSlice.actions;

export default notificationsSlice.reducer;